import inquiryOrderSaga from './inquiryOrder';

export default inquiryOrderSaga;
